import { render, staticRenderFns } from "./CitySuggestion.vue?vue&type=template&id=a2e883a4"
import script from "./CitySuggestion.vue?vue&type=script&lang=js"
export * from "./CitySuggestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports